import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';
import { Button, IButtonProps, SvgIcon } from '@gik/ui';
import { openAddToCalendarModal } from './AddToCalendarModal';
import { IAddToCalendarLinks } from '.';

export interface IAddToCalendarButtonProps extends IButtonProps {
  links: IAddToCalendarLinks;
  text?: React.ReactNode;
}

export function AddToCalendarButton({
  className,
  text = 'Add to calendar',
  links,
  ...otherProps
}: IAddToCalendarButtonProps): React.ReactElement {
  const bem = useBemCN('add-to-calendar-button');

  function handleAddToCalendar() {
    openAddToCalendarModal(links);
  }

  return (
    <Button
      {...bem(null, null, className)}
      size={'sm'}
      variant={'primary-outline'}
      pill
      append={<SvgIcon size="lg" name={'Calendar'} />}
      onClick={handleAddToCalendar}
      {...otherProps}
    >
      {text}
    </Button>
  );
}
